var _defs, _path, _rect, _rect2, _path2, _circle, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnleitung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.01,
    height: 336.88,
    viewBox: "0 0 282.01 336.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b8b43;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.36,274.8a71.55,71.55,0,0,1,85.54-70.19V50.42A13.32,13.32,0,0,0,220.58,37.1H154.05a37.1,37.1,0,0,0-74.2,0H13.32A13.32,13.32,0,0,0,0,50.42v263a13.32,13.32,0,0,0,13.32,13.32H170.8A71.39,71.39,0,0,1,148.36,274.8ZM117,57.43A20.33,20.33,0,1,1,137.28,37.1,20.33,20.33,0,0,1,117,57.43Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.03,
    y: 180.98,
    width: 161.84,
    height: 22.73,
    rx: 11.37
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.03,
    y: 109.35,
    width: 161.84,
    height: 22.73,
    rx: 11.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.29,303.75a2,2,0,0,1-2-2V183.9a2,2,0,0,1,4,0V301.75A2,2,0,0,1,7.29,303.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 219.94,
    cy: 274.8,
    r: 62.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227,256.74a7.09,7.09,0,0,0-14.18,0v55.91a7.09,7.09,0,0,0,14.18,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.94,244.34a7.17,7.17,0,1,0-7.09-7.17,7.13,7.13,0,0,0,7.09,7.17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149,274.8a72.28,72.28,0,0,1,3.49-22.19H47.4A11.41,11.41,0,0,0,36,264h0A11.41,11.41,0,0,0,47.4,275.35H149C149,275.16,149,275,149,274.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnleitung);
export default __webpack_public_path__ + "static/media/Icon_Anleitung.cb3ff5896a0d67cb9266848e593edeb0.svg";
export { ForwardRef as ReactComponent };